import React from "react";
import { Box, Typography } from "@mui/material";

function WaitForCandidate() {
  const message = window.sessionStorage.getItem("waiting-for-candidate");
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignSelf="center"
      width={{ xs: "65%", sm: "60%", md: "40%" }}
      bgcolor="#FAFAFA"
      borderRadius={4}
      px={6}
      py={3}
      my={13}
      mx={"auto"}
    >
      <Typography
        variant="h2"
        fontSize="22px"
        fontWeight={600}
        textAlign="right"
        mt={2}
        mb={3}
        sx={{ color: "#00BE93" }}
      >
        درخواست شما پذیرفته شد.
      </Typography>
      <Typography
        variant="h2"
        textAlign="right"
        sx={{ direction: "rtl", fontWeight: "400" }}
        paragraph
      >
        {message}
      </Typography>
    </Box>
  );
}

export default WaitForCandidate;
